import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import Quiz from './Quiz';
import Feed from './Feed';
import Matches from './Matches';

export default function Roommates() {
  const [tab, setTab] = useState('feed');
  const [hasQuiz, setHasQuiz] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/roommates/quiz').then(res => {
      setHasQuiz(!!res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="page-container flex justify-center py-20">
        <div className="w-8 h-8 border-2 border-[#C8A800] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!hasQuiz) {
    return <Quiz onComplete={() => setHasQuiz(true)} />;
  }

  return (
    <div className="page-container">
      <div className="flex items-center justify-between mb-6">
        <h1 className="section-title">Roommate Finder</h1>
        <button onClick={() => setTab('quiz')} className="btn-ghost text-sm border border-[#DDDDDD]">
          Retake Quiz
        </button>
      </div>

      {tab === 'quiz' ? (
        <Quiz onComplete={() => setTab('feed')} />
      ) : (
        <>
          <div className="flex gap-1 mb-6 bg-[#F0F0F0] p-1 rounded-lg w-fit">
            {['feed', 'matches'].map(t => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`px-4 py-2 rounded-md text-sm font-medium capitalize transition-colors ${
                  tab === t
                    ? 'bg-white border border-[#E8E8E8] shadow-sm text-[#1B1B1B]'
                    : 'text-[#777777] hover:text-[#1B1B1B]'
                }`}
              >
                {t === 'feed' ? 'Discover' : 'My Matches'}
              </button>
            ))}
          </div>

          {tab === 'feed' && <Feed />}
          {tab === 'matches' && <Matches />}
        </>
      )}
    </div>
  );
}
